import { cva } from 'class-variance-authority';

export const inlineMessageStyles = cva('flex box-border whitespace-pre-line', {
  variants: {
    intent: {
      default: 'bg-neutral-subtle',
      success: 'bg-positive-subtle',
      warning: 'bg-warning-subtle',
      error: 'bg-negative-subtle',
      info: 'bg-info-subtle',
      neutral: 'bg-surface-strong',
    },
    size: {
      default: 'rounded-s text-body-l gap-x-s pl-m pr-xxs',
      small: 'rounded-m text-body-s gap-x-xs p-m',
    },
  },
  defaultVariants: {
    intent: 'default',
    size: 'default',
  },
});

export const inlineMessageContentStyles = cva(
  'flex flex-col flex-auto self-center',
  {
    variants: {
      size: {
        default: 'gap-xxs mt-m',
        small: 'gap-m',
      },
      canDismiss: {
        true: '',
        false: '',
      },
      hasAction: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        size: 'default',
        canDismiss: false,
        class: 'pr-xs',
      },
      {
        size: 'default',
        hasAction: true,
        class: 'mb-xxs',
      },
      {
        size: 'default',
        hasAction: false,
        class: 'mb-m',
      },
    ],
    defaultVariants: {
      size: 'default',
      canDismiss: false,
      hasAction: false,
    },
  },
);

export const inlineMessageTextGroupStyles = cva('', {
  variants: {
    size: {
      default: 'flex flex-col gap-m',
      small: 'flex flex-col gap-xs',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
